import {useSuspenseQuery} from '@tanstack/react-query';
import {severityScaleSchema} from 'shared';

import {api} from '@/lib/ky';

import {severityScaleKeys} from './queryKeys';

import type {
  QueryConfig,
  ExtractFnReturnType,
  QueryConfig2,
} from '@/lib/react-query';

export const getSeverityScale = async (id: string) => {
  const data = await api.get(`severityscales/${id}`).json();
  return severityScaleSchema.parse(data);
};

export const useSeverityScale = (
  id: string,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: severityScaleKeys.detail(id),
    queryFn: () => getSeverityScale(id),
  });
};
export const useSeverityScaleLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getSeverityScale;
